var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_register"},[_c('a-card',[_c('a-tabs',{attrs:{"default-active-key":"1"},on:{"change":_vm.tabChange}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"应用"}}),_c('a-tab-pane',{key:"2",attrs:{"tab":"解决方案"}})],1),(_vm.tabNumber == 1)?_c('app-register-tab'):_vm._e(),(_vm.tabNumber == 2)?_c('solution-tab'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }